module.exports = __webpack_public_path__ + "img/Venezuelan.c9d42177.svg";